var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGhanaflag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3214_10168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 0.96875C7.08672 0.96875 2.92422 4.08125 1.38672 8.46875H22.6117C21.0742 4.08125 16.9117 0.96875 11.9992 0.96875Z",
    fill: "#C94747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 23.4688C16.9117 23.4688 21.0742 20.3562 22.6117 15.9688H1.38672C2.92422 20.3562 7.08672 23.4688 11.9992 23.4688Z",
    fill: "#699635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3875 8.46875C0.975 9.63125 0.75 10.9062 0.75 12.2188C0.75 13.5312 0.975 14.8063 1.3875 15.9688H22.6125C23.025 14.8063 23.25 13.5312 23.25 12.2188C23.25 10.9062 23.025 9.63125 22.6125 8.46875H1.3875Z",
    fill: "#FFCE31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.2062L14.325 15.9688L13.425 13.1188L15.75 11.2812H12.9L12 8.46875L11.1375 11.2812H8.25L10.575 13.1188L9.675 15.9688L12 14.2062Z",
    fill: "#3E4347"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3214_10168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.96875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhanaflag);
export default __webpack_public_path__ + "static/media/ghanaflag.f7048ea39bc495e59586c8ca525a6786.svg";
export { ForwardRef as ReactComponent };